import { Command, CommandGroup, CommandInput } from '@/components/ui/Command.tsx'
import React, { useState } from 'react'
import { CommandList } from 'cmdk'
import { useOverlayStore } from '@/components/common/propertyPopoverOverlay/overlay/useOverlayStore.ts'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'

type PropsT = {
  showSearch?: boolean
  searchLabel?: string
  children: React.ReactNode
  handleValueChange?: (value: string) => void
  propertiesFlat: PopoverProperty[]
  setCurrentProperties: (properties: PopoverProperty[]) => void
  inputClassName?: string
  handleSearch?: (val: string) => void
  showAllSearchResults?: boolean
  className?: string
  selectedParent: string | null | undefined
  debug?: boolean
  initialProperties: PopoverProperty[]
  selectedNestedProperties: PopoverProperty[][] | []
}

export default function PropertyCommand({
  showSearch,
  searchLabel,
  children,
  propertiesFlat,
  handleValueChange,
  setCurrentProperties,
  inputClassName,
  handleSearch,
  showAllSearchResults,
  className,
  selectedParent,
  // debug,
  selectedNestedProperties,
  initialProperties,
}: PropsT) {
  const setSwipeDownDisabled = useOverlayStore(state => state.setSwipeDownDisabled)

  const [searchIsActive, setSearchIsActive] = useState(false)

  const handleFilter = (value: string, search: string) => {
    if (search) {
      setSearchIsActive(true)

      const property = propertiesFlat.find(p => p.searchableValue === value)
      const searchableValue = property?.searchableValue || value
      // if (debug) console.log(`handle filter`, {search}, {value} )

      if (selectedParent) {
        setCurrentProperties(propertiesFlat.filter(p => p.parent === selectedParent))
      } else {
        setCurrentProperties(propertiesFlat)
      }
      handleSearch?.(search)

      if (showAllSearchResults) return 1
      return searchableValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0
    }

    if (searchIsActive) {
      // Restore the correct nesting level based on selectedNestedProperties
      if (selectedNestedProperties.length > 0) {
        // Get the current nesting level properties
        const currentNestingLevel = selectedNestedProperties[selectedNestedProperties.length - 1]
        setCurrentProperties(currentNestingLevel)
      } else {
        // If not nested, restore initial properties
        setCurrentProperties(initialProperties)
      }
      setSearchIsActive(false)
    }

    return 1
  }
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    // The event target is the scrollable element
    const scrollTop = event.currentTarget.scrollTop
    setSwipeDownDisabled(scrollTop > 5)
  }

  return (
    <Command
      className={className}
      filter={handleFilter}
      onKeyDown={e => {
        e.stopPropagation()
      }}
    >
      {showSearch && (
        <CommandInput
          placeholder={searchLabel}
          className={inputClassName}
          onValueChange={handleValueChange}
        />
      )}
      <CommandList tabIndex={0}>
        <CommandGroup onScroll={handleScroll}>{children}</CommandGroup>
      </CommandList>
    </Command>
  )
}
